import {ApplicationRef, ComponentFactoryResolver, Injectable, Injector} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {RouterOutletComponent} from '../../shared/router-outlet/router-outlet.component';
import {PaginaDinamicaComponent} from '../../shared/pagina-dinamica/pagina-dinamica.component';

@Injectable()
export class GestaoGuard implements CanActivate {
  isLoaded = false;
  home = {};

  constructor(public _router: Router, private _http: HttpClient, private resolver: ComponentFactoryResolver,
              private appRef: ApplicationRef,
              private injector: Injector) {
  }

  constructAppRoutes(modulos) {
    return modulos.map((modulo) => {
      if (!modulo.components && modulo.children) {
        modulo.path = modulo.nome ? modulo.nome : '';
        modulo.component = RouterOutletComponent;
        this.constructAppRoutes(modulo['children']);
        return modulo;
      } else if (modulo.componentes) {
        delete modulo.data;
        modulo.data = JSON.parse(JSON.stringify(modulo));
        modulo.path = modulo.nome ? modulo.nome : '';
        modulo.component = PaginaDinamicaComponent;
        if (modulo.home) {
          this.home = Object.assign({}, modulo);
          this.home['path'] = '';
          this.home['showMenu'] = false;
        }
        return modulo;
      } else if (modulo.loadChildren) {
        modulo.path = modulo.nome ? modulo.nome : '';
      }
    });
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(resolve => {
      if (this.isLoaded) {
        resolve(true);
        return;
      }
      this._http.get('assets/data/modulos-gestao.json')
        .subscribe(menuGroups => {
          // todo posição dos dados

          const modulos = menuGroups['modulos'].filter((modulo) => modulo.components || modulo.children ||
            modulo.componentes || modulo.loadChildren);
          route.routeConfig.children = this.constructAppRoutes(modulos);
          route.routeConfig.children.push(this.home);

          this.isLoaded = true;
          resolve(false);

          let location = window.location.pathname;
          if (location === '/login' || location === '/') {
            location = '/gestao';
          }
          this._router.navigateByUrl(location);
        });
    });
  }
}
